/*
 * @Author: liguokang
 * @Date: 2021-06-03 19:15:28
 * @LastEditors: liguokang
 * @LastEditTime: 2021-07-07 12:05:58
 * @Description:
 * @Copyrigh: ©2021 杭州杰竞科技有限公司 版权所有
 */
import User from '@/core/user';

const userInfo = {
  state: {
    phone: User.phone,
    uid: User.uid,
    openId: User.openId,
    appId: User.appId,
    instId: User.instId,
    organizationInfo: {},
  },
  mutations: {
    SETPHONE: (state, data) => {
      state.phone = data;
    },
    SETUID: (state, data) => {
      state.openId = data;
    },
    SETOPENID: (state, data) => {
      state.uid = data;
    },
    SETAPPID: (state, data) => {
      state.appId = data;
    },
    SETINSTID: (state, data) => {
      state.instId = data;
    },
    SETORGANINFO: (state, data) => {
      state.organizationInfo = data;
    },
  },
  actions: {
    setUserInfo({ commit }, data) {
      const { phone, openId, uid, appId, instId } = { ...data };
      commit('SETPHONE', phone);
      commit('SETOPENID', openId);
      commit('SETUID', uid);
      commit('SETAPPID', appId);
      commit('SETINSTID', instId);
    },
    setUserPhone({ commit }, data) {
      const { phone } = { ...data };
      commit('SETPHONE', phone);
    },
    setUserOpenId({ commit }, data) {
      const { openId } = { ...data };
      commit('SETOPENID', openId);
    },
    setUserUid({ commit }, data) {
      const { uid } = { ...data };
      commit('SETPHONE', uid);
    },
    setUserAppId({ commit }, data) {
      const { appId } = { ...data };
      commit('SETPHONE', appId);
    },
    setUserInstId({ commit }, data) {
      const { instId } = { ...data };
      commit('SETPHONE', instId);
    },
    setOrganInfo({ commit }, data) {
      commit('SETORGANINFO', data);
    },
  },
};

export default userInfo;



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js